var ErrorReporterService = /** @class */ (function () {
    function ErrorReporterService(adapter, isDebug) {
        if (isDebug === void 0) { isDebug = false; }
        this.adapter = adapter;
        this.isDebug = isDebug;
    }
    ErrorReporterService.prototype.reportError = function (error) {
        if (this.isDebug) {
            console.log(error);
            return;
        }
        this.adapter.reportError(error);
    };
    ErrorReporterService.prototype.reportMessage = function (message) {
        if (this.isDebug) {
            console.log(message);
            return;
        }
        this.adapter.reportMessage(message);
    };
    return ErrorReporterService;
}());
export { ErrorReporterService };
//# sourceMappingURL=ErrorReporterService.js.map